import React, {useContext} from "react"
import { Link } from "gatsby"
import sticker from "../../../images/Stickers-joinsticker.png"
import "./JoinSection.scss"

const RegisterButton = () => {
	//const isParentLoggedIn = (typeof window !== "undefined") && window.localStorage.getItem("cognito_user");
	//if(isParentLoggedIn === null){
		return (
			<>
			<Link to={`/register/`} className="btn btn-primary extra-margin"
			data-analytics='{"event":"GrownupEngagement", "eventCategory":"Child Homepage- Engagement", "eventAction":"CTA Click - Sign up", "eventLabel":"Sign up for EE PhoneSmart"}'>Sign up for EE PhoneSmart</Link>
			<p className="network">It’s available to any kids on any network</p>
			</>
		)
	//}else{
		//return ('')
	//}
}
const JoinSection = () => {
	return (
		<div className="join-section">
			<div className="kidcontent">
				<img src={sticker} alt="sticker thumbsup"></img>
				<h2>WANT TO JOIN?</h2>
				<p>Can't wait to get started?
					<span> No probs.</span><br/>
					 Just ask a trusted grown up to help you sign up and away you go!
				</p>
				<RegisterButton />
			</div>
		</div>
	)
}

export default JoinSection
